import React, { useEffect, useState, useMemo } from "react";
import {
  Modal, Spin, Timeline, Empty,
} from "antd";
import moment from "moment";
import { toast } from "react-toastify";
import { fetchHistory } from "../../../../actions/qc";
import useAbortController from "../../../Common/hooks/useAbortController";
import "./QcHistoryActivityModal.css";

const QcHistoryActivityModal = ({
  open,
  onCancel,
  record,
  isCalledFromDashboard = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [activityData, setActivityData] = useState([]);
  const { setNewAbortController } = useAbortController();

  const fetchActivityLog = async () => {
    if (!record) return;

    setLoading(true);
    const newAbortController = setNewAbortController();

    let payload = {
      date: "",
      update_type: "",
      search: "",
      genista_id: record.genista_id,
      test: record.analysis,
      source: "QC",
    };

    if (isCalledFromDashboard) {
      payload = { genista_id: record.genista_id, test: record.analysis };
    }

    const {
      success, results, message, canceled,
    } = await fetchHistory(payload, newAbortController.signal);

    if (success && results) {
      setActivityData(results);
    } else if (!canceled) {
      toast.error(message || "Failed to fetch activity log");
      setActivityData([]);
    }

    setLoading(canceled === undefined ? false : canceled);
  };

  const timelineItems = useMemo(() => activityData.map((item) => ({
    label: (
      <div className="QcHistoryActivityModal__Timeline__LabelDiv">
        <div className="QcHistoryActivityModal__Timeline__LabelDiv__Actor">
          <span title={item.actor}>{item.actor}</span>
        </div>
        <span>
          {moment(`${item.date}, ${item.time}`).format("MM-DD-YY, hh:mm:ss A")}
        </span>
      </div>
    ),
    children: (
      <div className="QcHistoryActivityModal__Timeline__CardBody">
        {item.update_type}
        <br />
        {item.sentence}
      </div>
    ),
  })), [activityData]);

  useEffect(() => {
    if (open && record) {
      fetchActivityLog();
    } else {
      setActivityData([]);
    }
  }, [open, record]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Activity Log"
      width={900}
      footer={null}
      centered
      destroyOnClose
      className="QcHistoryActivityModal"
    >
      <Spin spinning={loading} size="large">
        {record && (
          <div className="QcHistoryActivityModal__Subheading">
            {record.genista_id && (
              <span>
                Genista ID:
                {record.genista_id}
              </span>
            )}
            {record.genista_id && record.analysis && <span className="QcHistoryActivityModal__SubheadingSeparator">|</span>}
            {record.analysis && (
              <span>
                Test:
                {record.analysis}
              </span>
            )}
          </div>
        )}
        {activityData.length === 0 && !loading && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
        {activityData.length > 0 && (
          <div className="QcHistoryActivityModal__Timeline__Container">
            <Timeline
              mode="left"
              className="QcHistoryActivityModal__Timeline"
              items={timelineItems}
            />
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export default QcHistoryActivityModal;
